import { number, shape, string } from "prop-types"

export const taskType = shape({
    code: string.isRequired,
    parent: string,
    acronym: string.isRequired,
    name: string.isRequired,
    impact: number.isRequired,
})